import { render, staticRenderFns } from "./Gallery-Module.vue?vue&type=template&id=4dd0fc46&"
import script from "./Gallery-Module.vue?vue&type=script&lang=js&"
export * from "./Gallery-Module.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports